import { Enrollment } from "@rms-types/modules/enrollment/entities/enrollment";

const index = "enrollment";
const getOneEnrollment = (enrollmentId: Enrollment["id"]) => `${index}/${enrollmentId}` as string;
const approveEnrollment = (enrollmentId: Enrollment["id"]) => `${index}/${enrollmentId}/approve-enrollment` as string;
const getEnrollmentNotes = (enrollmentId: Enrollment["id"]) => `${getOneEnrollment(enrollmentId)}/note`;
const getEnrollmentPayments = (enrollmentId: Enrollment["id"]) => `${getOneEnrollment(enrollmentId)}/payment`;

export const enrollmentEndpoint = Object.freeze({
  enrollment: index,
  enrollmentCount: `${index}/enrollment-count`,
  enrollmentSidebar: `${index}/enrollment-sidebar`,
  approveEnrollment,
  getOneEnrollment,
  getEnrollmentNotes,
  getEnrollmentPayments,
  signedUrl: `${index}/signed-url`,
});
